/* eslint-disable no-alert */
import axios from '@fs/zion-axios'
import { v4 as uuidv4 } from 'uuid'
import { dataURItoBlob } from '../../helpers/image_helper'

const azServiceBaseURL = 'https://discoveryplatformweb.azurewebsites.net/api'

const getAzureHeaders = () => {
  // eslint-disable-next-line camelcase
  const azBearerToken = JSON.parse(localStorage.getItem('FS.ds-bearerToken'))?.access_token

  if (!azBearerToken) {
    alert("Couldn't find an azure bearer token!")
  }

  return {
    Authorization: `Bearer ${azBearerToken}`,
  }
}

export const getDiscoveryUser = async () => {
  const response = await axios.get(`/service/discovery/common/userperson`)
  return response.data
}

export const getExperienceDataStatus = async (azUSID) => {
  const response = await axios.get(`${azServiceBaseURL}/DataStatus/${azUSID}`)
  return response.data
}

export const uploadTakeAway = async ({
  imgDataURL,
  azUSID,
  usage = 'pictureTakeAway',
  description = 'Picture_My_Heritage',
}) => {
  const targetBlob = dataURItoBlob(imgDataURL)
  const fd = new FormData()
  fd.append('sessionId', azUSID)
  fd.append('usage', usage)
  fd.append('description', description)
  fd.append('file', targetBlob, `${uuidv4()}.jpg`)

  const response = await axios.post(`${azServiceBaseURL}/upload`, fd, null, {
    headers: getAzureHeaders(),
  })
  return response.data
}

export const getTakeAways = async (azUSID) => {
  const response = await axios.get(`${azServiceBaseURL}/DiscoveryUserAssets/${azUSID}`, {
    headers: getAzureHeaders(),
  })
  return response.data
}

export const logoutDiscoveryStation = async ({ azUserSessionId, email = '' }) => {
  const response = await axios.post(
    `${azServiceBaseURL}/DiscoveryLogout`,
    { userSessionId: azUserSessionId, email },
    null,
    {
      headers: getAzureHeaders(),
    }
  )
  return response.data
}
